import { render, staticRenderFns } from "./WaitingTab.vue?vue&type=template&id=31b38e29&"
import script from "./WaitingTab.vue?vue&type=script&lang=js&"
export * from "./WaitingTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports